// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"72533311","497":"93f54ea9","513":"533a17cf","778":"0a536c8a","845":"d4b6b59c","998":"8edfed61"}[chunkId] + ".chunk.js";
};